import React from 'react';

import { Button } from '@/components/global/Button';

import { TOnboardingError } from '@/services/requests/Recommendation/types/template4';

import { getImage } from '@/helpers/ImageHelper';
import { getValue } from '@/helpers/GetValueHelper';

type TProps = {
  data: TOnboardingError;
  onBack: () => void;
};

export function ErrorScreen({ data, onBack }: TProps) {
  const { title, description } = data;

  const image = getImage(data.image, 'web');
  const formattedImage = getValue(image, 'image.url', '');

  return (
    <div className="vitrine-template4__screen-content">
      <div className="vitrine-template4__box1">
        <h2
          className="vitrine-template4__header"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {description && (
          <p className="vitrine-template4__description">{description}</p>
        )}

        <div className="vitrine-template4__actions">
          <Button
            className="vitrine-template4__button"
            text="Tentar novamente"
            onClick={onBack}
          />
        </div>
      </div>
      <div className="vitrine-template4__box2">
        <img
          className="vitrine-template4__image"
          src={formattedImage}
          data-testid="image"
          alt="test..."
        />
      </div>
    </div>
  );
}
